import { Component, Input, OnInit } from '@angular/core';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FlowchartHistory',
  templateUrl: './FlowchartHistory.component.html',
  styleUrls: ['./FlowchartHistory.component.scss']
})
export class FlowchartHistoryComponent implements OnInit {

  constructor() { }

  BaseUrl:String=environment.BaseUrl

  @Input() DataList_History:Array<FlowchartPaper_History_Interface>=[]

  ngOnInit() {
  }

}
